import React from 'react'
import CapacityAllocation from './CapacityAllocation';

const CapacityAllocationAMC = () => {
    return (<>
        <CapacityAllocation type='AMC' />
    </>)
}
export default CapacityAllocationAMC;